import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { fetchProducts } from '../actions/ProductActions';
import { fetchFilteredProducts } from '../actions/FilterActions';
import ProductCard from './ProductCard';
import { SimpleProductPageSkeleton } from './HomeSkeletons';
// import { selectNewProducts } from '../selectors/ProductSelector';
import Pagination from './Pagination';

const NewProducts = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { loading, error, count, filteredProducts } = useSelector((state) => state.filters);
  // const newProducts = useSelector(selectNewProducts);
  const productsPerPage = 30;
  const totalPages = Math.ceil(count / productsPerPage);

  useEffect(() => {
    dispatch(fetchFilteredProducts({
      tags: ['NEW ARRIVAL'],
      page: currentPage,
      status: 'published',
      pagination: productsPerPage,
    }));
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (loading)
    return (
      <SimpleProductPageSkeleton
        gridClassName="products-grid"
        cardCount={12}
        wrapperClassName="new-products-section"
      />
    );
  if (error) return <div>Error: {error}</div>;

  if (filteredProducts && filteredProducts.length === 0) {
    return (
      <div className="new-products-section">
        <h3 className="new-products-title">New Arrivals</h3>
        <p className="new-products-description">Just landed - explore our latest additions</p>
        <div className="no-new-products-message">
          No new products available at the moment.
        </div>
      </div>
    );
  }

  return (
    <div className="new-products-section">
      <h3 className="new-products-title">New Arrivals</h3>
      <p className="new-products-description">Just landed - explore our latest additions</p>
      <div className="products-grid">
        {filteredProducts && filteredProducts.length > 0 && (
          filteredProducts.map((product) => (
            <ProductCard key={product.product_id} product={product} preferredTag="NEW ARRIVAL" />
          ))
        )}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default NewProducts;
